import React, { useState, useEffect } from 'react';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import SummaryApi from '../common'; 
import { toast } from 'react-toastify';

const ResetPassword = () => {
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [data, setData] = useState({
        password: "",
        confirmPassword: ""
    });
    const [email, setEmail] = useState('');
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {


        if (location.state?.email) {
            setEmail(location.state.email);
        } else {
            toast.error("دخول غير مسموح ");
            navigate('/forgot-password');
        }
    }, [location.state, navigate]);

    const handleOnChange = (e) => {
        const { name, value } = e.target;
        setData((prev) => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
    
        if (!data.password || !data.confirmPassword) {
            toast.error("من فضلك تاكد من كتابة كلمة المرور وتاكيد كلمة المرور");
            return;
        }
    
        if (data.password !== data.confirmPassword) {
            toast.error("كلمة المرور وتاكيد كلمة المرور غير متطابقين");
            return;
        }
    
        try {
            const dataResponse = await fetch(SummaryApi.ResetPassword.url, {
                method: SummaryApi.ResetPassword.method,
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    email: email,
                    password: data.password,
                    confirmPassword: data.confirmPassword, 
                }),
            });
    
            const dataApi = await dataResponse.json();
    
            if (dataApi.success) {
                toast.success("تم تجديد كلمة المرور بنجاح");
                navigate('/login');
            } else if (dataApi.error) {
                toast.error(dataApi.message);
            }
        } catch (error) {
            toast.error('حدث خطأ حاول مره اخرى');
        }
    };
    

    return (
        <section id='ResetPassword'>
            <div className='mx-auto container p-4'>
                <div className='bg-white p-5 w-full max-w-sm mx-auto'>
                    <form className='pt-6 flex flex-col gap-2 text-right rtl' onSubmit={handleSubmit}>
                        <div>
                            <label>: كلمة المرور الجديدة </label>
                            <div className='bg-slate-100 p-2 flex'>
                                <input
                                    type={showPassword ? "text" : "password"}
                                    placeholder='ادخل كلمة المرور الجديدة '
                                    name='password'
                                    value={data.password}
                                    onChange={handleOnChange}
                                    className='w-full h-full outline-none bg-transparent'
                                />
                                <div className='cursor-pointer text-xl' onClick={() => setShowPassword((prev) => !prev)}>
                                    {showPassword ? < FaEye /> : <FaEyeSlash />}
                                </div>
                            </div>
                        </div>

                        <div>
                            <label>: تاكيد كلمة المرور الجديدة </label>
                            <div className='bg-slate-100 p-2 flex'>
                                <input
                                    type={showConfirmPassword ? "text" : "password"}
                                    placeholder='تاكيد ادخال كلمة المرور الجديدة '
                                    name='confirmPassword'
                                    value={data.confirmPassword}
                                    onChange={handleOnChange}
                                    className='w-full h-full outline-none bg-transparent'
                                />
                                <div className='cursor-pointer text-xl' onClick={() => setShowConfirmPassword((prev) => !prev)}>
                                    {showConfirmPassword ? < FaEye /> : <FaEyeSlash />}
                                </div>
                            </div>
                        </div>

                        <div className='flex justify-center'>
                            <button
                                type='submit'
                                className='flex items-center justify-center bg-blue-900 text-white px-4 py-2 text-sm rounded-full shadow-md hover:bg-blue-800 transition-colors duration-300 w-[120px] text-center whitespace-nowrap'
                            >
                                تاكيد كلمة المرور 
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </section>
    );
};

export default ResetPassword;
